
export const MENUS: any = [
  {
    path: '/home/admin',
    menu: 'menu.admin',
    order: 0
  },
  {
    path: '/home/testList',
    menu: 'menu.test_list',
    order: 1
  },
  {
    path: '/home/media',
    menu: 'menu.media',
    order: 2
  },
  {
    path: '/home/report',
    menu: 'menu.report',
    order: 3
  },
  {
    path: '/home/testingtool',
    menu: 'menu.testingtools',
    order: 4
  },
  {
    path: '/home/atlas',
    menu: 'menu.atlas',
    order: 5
  },
  {
    path: '/home/grammar_tool',
    menu: 'menu.grammar_tool',
    order: 6
  },
  {
    path: '/home/streamingtool',
    menu: 'menu.streamingtool',
    order: 7
  }
];


// WEBPACK FOOTER //
// ./src/app/home/menu.const.ts